'use client'

import { useRouter } from 'next/navigation'

type Props = {
  href: string
  title: string | null | undefined
  authorName: string | null | undefined
  dateFormatted: string
}

export const BookReviewRow = ({
  href,
  title,
  authorName,
  dateFormatted,
}: Props) => {
  const router = useRouter()

  return (
    <tr
      role="link"
      tabIndex={0}
      className="odd:bg-gray-100 even:bg-white hover:bg-gray-200 transition-colors cursor-pointer"
      onClick={() => router.push(href)}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          router.push(href)
        }
      }}
    >
      <td className="py-3 px-4 align-middle">
        <span className="line-clamp-1 md:line-clamp-none text-vi-red hover:underline">
          {title}
        </span>
        <div className="md:hidden text-sm md:text-base text-gray-700">
          {authorName}
        </div>
      </td>
      <td className="py-3 px-4 align-middle text-base hidden md:table-cell">
        {authorName}
      </td>
      <td className="py-3 px-4 align-middle text-base hidden md:table-cell">
        {dateFormatted}
      </td>
    </tr>
  )
}
